import React, { Component } from "react";
import { GridRow, GridColumn, Button, Toastr } from "arv-reactcomponents";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import { Checkout } from "npmlinks-constants";
import { getStrippedCart, readCookie } from "../../../utils";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";
import GTM from "../../../analytics/GTM";

@inject("LoginStore", "CheckoutStore")
@observer
class ProductActions extends Component {
  static triggerGtm(product, eventName) {
    GTM.pushWithEvent(
      {
        value: product.totalMRP,
        currency: Event.GTMEvent.GTM_CURRENCY,
        email: readCookie('cust_email'),
        content_name: product.styleName,
        content_category: product.pcmArticleType,
        content_id: product.skuId,
        contents: [
          {
            Id: product.skuId,
            brand: product.brand,
            desc:product.styleName,
            Qty: product.qty,
            size: product.size,
            dscnt: product.discountInPercentage,  
            price: product.totalGrossSP || product.totalMRP,
            mrp: product.totalMRP,
          },
        ],
      },
      eventName,
    );
  }
  static triggerRemoveGa(product, shouldBeFavorited) {
    const { skuId } = product;
    Analytics.trackEvent({
      category: window.pageType,
      action: shouldBeFavorited
        ? Event.action.MYBAG_PRODUCT_SHORTLIST
        : Event.action.MYBAG_PRODUCT_REMOVE,
      label: skuId,
    });
  }
  constructor() {
    super();
    this.onShorlist = this.onShorlist.bind(this);
    this.remove = this.remove.bind(this);
    this.removeAction = this.removeAction.bind(this);
  }
  onShorlist() {
    const { isUserLoggedIn } = this.props.LoginStore;
    if (isUserLoggedIn) {
      this.removeAction(true);
    } else {
      const { product } = this.props;
      this.props.CheckoutStore.setProductToBeFavorited(product);
      this.props.LoginStore.setloginModal(true);
    }
  }
  remove() {
    this.removeAction(false);
  }
  removeAction(shouldBeFavorited) {
    const { product } = this.props;
    const { isUserLoggedIn } = this.props.LoginStore;
    const extraKeys = shouldBeFavorited
      ? Checkout.CHECKOUT_EXTRA_KEYS_FOR_CART.FAVORITE
      : Checkout.CHECKOUT_EXTRA_KEYS_FOR_CART.REMOVE;
    const [productForRequest] = getStrippedCart([product], extraKeys);
    productForRequest.isFavourite = shouldBeFavorited;
    const requestBody = Object.assign({}, Checkout.CHECKOUT_BASE_REQUEST);
    requestBody.type = Checkout.CHECKOUT_API_ACTIONS.DELETE;
    requestBody.removeCart = [productForRequest];
    this.props.CheckoutStore.updateCart(requestBody, isUserLoggedIn).then(
      () => {
        ProductActions.triggerRemoveGa(product, shouldBeFavorited);
        if (shouldBeFavorited) {
          ProductActions.triggerGtm(product, Event.GTMEvent.PRODUCT_WISHLIST);
        }
        else {
          ProductActions.triggerGtm(product, Event.GTMEvent.REMOVE_PRODUCT);
        }
        Toastr.showToastr({
          className: "nwc-toastr-list-success nw-toastr",
          message: shouldBeFavorited
            ? Checkout.CHECKOUT_MESSAGES.PRODUCT.FAVORITE
            : Checkout.CHECKOUT_MESSAGES.PRODUCT.REMOVE,
          timeout: 3000,
        });
      },
    );
  }

  render() {
    const { className } = this.props;
    return (
      <GridRow className={`nw-cartproductview-actions ${className}`}>
        <GridColumn className="nw-cartproductview-actionscolumn">
          <Button
            onClick={this.onShorlist}
            className="nw-cartproductview-actionbutton nw-cartproductview-favbutton"
          >
            {Checkout.CHECKOUT_BUTTON_TEXTS.FAVORITE}
          </Button>
          <Button
            onClick={this.remove}
            className="nw-cartproductview-actionbutton .nw-cartproductview-removebutton"
          >
            {Checkout.CHECKOUT_BUTTON_TEXTS.REMOVE}
          </Button>
        </GridColumn>
      </GridRow>
    );
  }
}

ProductActions.defaultProps = {
  className: "",
};

ProductActions.wrappedComponent.propTypes = {
  className: PropTypes.string,
  product: PropTypes.shape({}).isRequired,
  LoginStore: PropTypes.shape({
    isUserLoggedIn: PropTypes.bool.isRequired,
    setloginModal: PropTypes.func.isRequired,
  }).isRequired,
  CheckoutStore: PropTypes.shape({
    setProductToBeFavorited: PropTypes.func.isRequired,
    updateCart: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("LoginStore", "CheckoutStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ProductActions.wrappedComponent,
  component: ProductActions,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CartProducts/ProductActions/index.js